module.exports = __webpack_public_path__ + "2d755e8bb3888710f8c96a4d53b6fea1.MP3";